export default "__VITE_ASSET__03e9aaf4__"